import { PartialType } from '@nestjs/swagger';
import { CreateAgenteTransporteDto } from './create-agente-transporte.dto';
export class UpdateAgenteTransporteDto extends PartialType(CreateAgenteTransporteDto) {}
